import { LogicNodeDefinition } from '../LogicNodeDefinition';

export interface ButtonNodeState {
  isOn: boolean;
}

export const ButtonNode: LogicNodeDefinition<ButtonNodeState> = {
  type: 'BUTTON',
  createDefaultState: () => ({ isOn: false }),
  process: (_input, state) => state?.isOn ?? false,
};
